import { render, staticRenderFns } from "./RequestOtherTest.vue?vue&type=template&id=9d9612be"
import script from "./RequestOtherTest.vue?vue&type=script&lang=js"
export * from "./RequestOtherTest.vue?vue&type=script&lang=js"
import style0 from "./RequestOtherTest.vue?vue&type=style&index=0&id=9d9612be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports